<template>
    <v-row no-gutters>
        <v-col cols="4">
            <v-card flat class="mx-auto" tile>
                <v-card-title>Browser Sessions</v-card-title>
                <v-card-subtitle>Manage and log out your active sessions on other browsers and devices.</v-card-subtitle>
            </v-card>
        </v-col>
        <v-col cols="8" class="justify-center">
            <v-form @submit.prevent="updatePassword">
                <v-card flat>
                    <div class="max-w-xl text-sm text-gray-600">
                        If necessary, you may log out of all of your other browser sessions across all of your devices. Some of your recent sessions are listed below; however, this list may not be exhaustive. If you feel your account has been compromised, you should also update your password.
                    </div>

                    <!-- Other Browser Sessions -->
                    <v-list v-if="sessions.length > 0" flat>
                        <v-list-item
                            v-for="(session, i) in sessions"
                            :key="i"
                            two-line
                        >
                            <v-list-item-icon>
                                <v-icon>mdi-laptop</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ session.agent.platform ? session.agent.platform : 'Unknown' }} - {{ session.agent.browser ? session.agent.browser : 'Unknown' }}
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    <div class="text-xs text-gray-500">
                                        {{ session.ip_address }},

                                        <span v-if="session.is_current_device" class="text-green-500 font-semibold">This device</span>
                                        <span v-else>Last active {{ session.last_active }}</span>
                                    </div>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>

                    <v-alert type="success" v-show="form.recentlySuccessful" class="ml-3" dismissible>
                        Done.
                    </v-alert>

                    <v-card-actions>
                        <v-btn
                            @click="confirmLogout"
                            color="blue-grey"
                            class="ma-2 white--text"
                        >
                            Log Out Other Browser Sessions
                        </v-btn>
                    </v-card-actions>
                </v-card>

                <!-- Log Out Other Devices Confirmation Modal -->
                <v-dialog v-model="confirmingLogout" max-width="600">
                    <v-card>
                        <v-card-title class="text-h5 grey lighten-2">
                            Log Out Other Browser Sessions
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="6" class="justify-center">
                                    Please enter your password to confirm you would like to log out of your other browser sessions across all of your devices.
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field
                                        ref="passwordInput"
                                        v-model="form.password"
                                        type="password"
                                        class="mt-1 block w-3/4"
                                        placeholder="Password"
                                        @keyup.enter="logoutOtherBrowserSessions"
                                    />

                                    <!-- <JetInputError :message="form.errors.password" class="mt-2" /> -->
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-divider />
                        <v-card-actions>
                            <v-spacer />
                            <v-btn @click="closeModal" color="red lighten-2" dark>
                                Cancel
                            </v-btn>

                            <v-btn
                                color="blue-grey"
                                class="ma-2 white--text"
                                :class="{ 'opacity-25': form.processing }"
                                :disabled="form.processing"
                                @click="logoutOtherBrowserSessions"
                            >
                                Log Out Other Browser Sessions
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-form>
        </v-col>
    </v-row>
</template>

<script>
export default {
    props: {
        sessions: Array,
    },
    data() {
        return {
            confirmingLogout: false,
            passwordInput: null,
            form: this.$inertia.form({
                password: '',
            }),
        };
    },
    methods: {
        confirmLogout(){
            this.confirmingLogout = true;

            setTimeout(() => this.passwordInput.focus(), 250);
        },

        logoutOtherBrowserSessions(){
            this.form.delete(route('other-browser-sessions.destroy'), {
                preserveScroll: true,
                onSuccess: () => this.closeModal(),
                onError: () => this.passwordInput.focus(),
                onFinish: () => this.form.reset(),
            });
        },

        closeModal(){
            this.confirmingLogout = false;

            this.form.reset();
        },
    },
}
</script>

<style scoped>

</style>
